import React from 'react';
import { useTranslation } from 'react-i18next';
import { CallActivityEventTimeline } from './CallActivityEventTimeline';
import { useCallTraceEvents } from './useCallTraceEvents';
import styles from './CallActivityLogPanel.module.css';

interface CallActivityTraceDetailsProps {
  callTraceId?: string | null;
  cxoneContactId?: string | null;
}

export function CallActivityTraceDetails({
  callTraceId,
  cxoneContactId,
}: CallActivityTraceDetailsProps) {
  const { t } = useTranslation('activityLog');
  const { events, isLoading, error } = useCallTraceEvents({ callTraceId, cxoneContactId });

  if (isLoading) {
    return <div className={styles.traceDetailsLoading}>{t('loadingEvents')}</div>;
  }

  if (error) {
    return <div className={styles.traceDetailsError}>{error}</div>;
  }

  if (events.length === 0) {
    return <div className={styles.traceDetailsEmpty}>{t('noEvents')}</div>;
  }

  return <CallActivityEventTimeline events={events} />;
}

export default CallActivityTraceDetails;
